<template>
  <div>
    <v-row>
      <v-btn small fab left class="ml-6 my-2" :color="getThemeColor" dark @click="goBack()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </v-row>
    <Loader></Loader>
    <VueHtml2pdf
      :show-layout="false"
      :float-layout="false"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="Payment-Receipt"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="100%"
      ref="html2Pdf"
    >
      <template v-slot:pdf-content>
        <section>
          <div class="invoice-box" id="invoice">
            <table cellpadding="0" cellspacing="0">
              <tr class="top">
                <td colspan="4">
                  <table>
                    <tr>
                      <td class="title">
                        {{getUserSchool.schname}}
                        <v-img
                          fab
                          left
                          height="70"
                          width="70"
                          style="border-radius:50%"
                          :src="getApiUrl+'/images/logos/'+getUserSchool.emis+'/'+logos[0]"
                        ></v-img>
                      </td>

                      <td>
                        {{getUserSchool.physical_address}}
                        <br />
                        {{getUserSchool.city}}, {{getUserSchool.pcode}}
                        <br />
                        {{getUserSchool.sch_tel}}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr class="information">
                <td colspan="4">
                  <table>
                    <tr>
                      <td>
                        <v-img
                          class="mr-6"
                          fab
                          left
                          height="70"
                          width="70"
                          style="border-radius:50%;float:left"
                          :lazy-src="getApiUrl+'/images/students_profile_pics/def_user_2.png'"
                          :src="getApiUrl+'/images/students_profile_pics/'+getUserSchool.emis +'/' +student.class +'/' +student.sid +'.jpeg'"
                        ></v-img>
                        <span>
                          <span>{{student.lname}} {{student.fname}} [ {{student.sid}} ]</span>
                          <br />
                          <span>{{student.class}}</span>
                          <br />
                          <span class="headline">Transactions Date: {{payment.entry_date}}</span>
                        </span>
                        <v-col cols="12" sm="12" md="12"></v-col>
                      </td>

                      <td>
                        {{getUserSchool.bank}}
                        <br />
                        {{getUserSchool.account_number}}
                        <br />
                        {{getUserSchool.account_type}}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr class="heading">
                <td class="text-left">Reference</td>
                <td colspan="2" class="text-left">Description</td>
                <td class="text-right">Amount</td>
              </tr>

              <tr
                class="item"
                id="item-tr"
                v-for="(payment,index) in payments"
                :key="index+Math.random()"
              >
                <td class="text-left">{{payment.rec_num}}</td>
                <td colspan="2" class="text-left">{{payment.description}}</td>
                <td class="text-right">{{payment.amount}}</td>
              </tr>

              <tr class="total">
                <td colspan="3"></td>
                <td>Total: {{getCurrency}}{{totalPayment.toFixed(2)}}</td>
              </tr>

              <tr class="heading">
                <td colspan="4" class="text-center">Mini Statement</td>
              </tr>

              <tr class="heading">
                <td colspan="3" class="text-right">{{studentFinance.comment}}</td>
                <td>{{getCurrency}} {{studentFinance.op}}</td>
              </tr>

              <tr class="heading">
                <td colspan="3" class="text-right">Year School Fees</td>
                <td>{{getCurrency}} {{studentFinance.curfee}}</td>
              </tr>

              <tr class="heading">
                <td colspan="3" class="text-right">Total Billings Due</td>
                <td>{{getCurrency}} {{studentFinance.future_billings_unpaid_sum}}</td>
              </tr>

              <tr class="heading">
                <td colspan="3" class="text-right">Total Due for Year</td>
                <td>{{getCurrency}} {{studentFinance.total_due}}</td>
              </tr>

              <tr class="heading">
                <td colspan="3" class="text-right">Total Billings Paid</td>
                <td>{{getCurrency}} {{studentFinance.future_billings_paid_sum}}</td>
              </tr>

              <tr class="heading">
                <td colspan="3" class="text-right">Total School Fees Paid</td>
                <td>{{getCurrency}} {{studentFinance.all_pay_sum}}</td>
              </tr>

              <tr class="heading">
                <td colspan="3" class="text-right">Balance Due Year</td>
                <td>{{getCurrency}} {{studentFinance.balance_due_year}}</td>
              </tr>
            </table>
          </div>
        </section>
      </template>
    </VueHtml2pdf>
  </div>
</template>

<script>
import axios from "../../plugins/axios";
import VueHtml2pdf from "vue-html2pdf";
import Loader from "@/components/Loader.vue";

export default {
  components: { VueHtml2pdf, Loader },
  mounted() {
    this.student = this.$route.params.student;
    this.payment = this.$route.params.payment;
    this.studentFinance = this.$route.params.studentFinance;
    this.$store.commit("setLoader", true);
    axios
      .postDataWithToken(
        "/auth/get-all-payments-same-date",
        {
          date: this.$route.params.payment.entry_date,
          sid: this.$route.params.student.sid
        },
        this.getAccessToken
      )
      .then(payments => {
        this.payments = payments;
        payments.forEach(payment => {
          this.totalPayment += Number(payment.amount);
        });
        this.$store.commit("setLoader", false);
        this.getLogos(this.getUserSchool.emis);
        this.generateReport();
      });
  },

  data: () => ({
    student: {},
    payment: {},
    payments: [],
    studentFinance: {},
    totalPayment: 0,
    logos: []
  }),
  computed: {
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    }
  },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    getSelectedStudent() {
      const sid = event.target.value;
      axios
        .postDataWithToken(
          "/auth/get-selected-student-payment",
          { sid: sid },
          this.getAccessToken
        )
        .then(student => {
          this.selStudent = student;
        });
    },
    getDate() {
      this.selDate = event.target.value;
    },
    addRow() {
      this.items.push({ description: "Description", quantity: 1, price: 0 });
    },
    goBack() {
      this.$router.back();
    },
    getLogos(emis) {
      axios
        .postData("/auth/get-logos-for-given-school", {
          folder: "logos",
          emis: emis
        })
        .then(logos => {
          this.logos = logos;
        });
    }
  },
  filters: {
    currency(value) {
      return value.toFixed(2);
    }
  }
};
</script>

<style lang="scss">
@media print {
  * {
    -webkit-print-color-adjust: exact !important; /* Chrome, Safari */
    color-adjust: exact !important; /*Firefox*/
  }
}

* {
  -webkit-print-color-adjust: exact !important; /* Chrome, Safari */
  color-adjust: exact !important; /*Firefox*/
}

.invoice-box {
  min-width: 800px;
  margin: auto;
  padding: 30px;
  border: 1px solid #eee;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  font-size: 16px;
  line-height: 24px;
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
  color: #555;
}

.invoice-box table {
  width: 100%;
  line-height: inherit;
  text-align: left;
}

.invoice-box table td {
  padding: 5px;
  vertical-align: top;
}

.invoice-box table tr td:nth-child(n + 2) {
  text-align: right;
}

.invoice-box table tr.top table td {
  padding-bottom: 20px;
}

.invoice-box table tr.top table td.title {
  font-size: 45px;
  line-height: 45px;
  color: #333;
}

.invoice-box table tr.information table td {
  padding-bottom: 40px;
}

.invoice-box table tr.heading td {
  background: #eee;
  border-bottom: 1px solid #ddd;
  font-weight: bold;
}

.invoice-box table tr.details td {
  padding-bottom: 20px;
}

.invoice-box table tr.item td {
  border-bottom: 1px solid #eee;
}

.invoice-box table tr.item.last td {
  border-bottom: none;
}

.invoice-box table tr.item input {
  padding-left: 5px;
}

.invoice-box table tr.item td:first-child input {
  margin-left: -5px;
  width: 100%;
}

.invoice-box table tr.total td:nth-child(2) {
  border-top: 2px solid #eee;
  font-weight: bold;
}

.invoice-box input[type="number"] {
  width: 60px;
}

@media only screen and (max-width: 600px) {
  .invoice-box table tr.top table td {
    width: 100%;
    display: block;
    text-align: center;
  }

  .invoice-box table tr.information table td {
    width: 100%;
    display: block;
    text-align: center;
  }
}

/** RTL **/
.rtl {
  direction: rtl;
  font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
    sans-serif;
}

.rtl table {
  text-align: right;
}

.rtl table tr td:nth-child(2) {
  text-align: left;
}
</style>